import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Home, BookOpen, Newspaper, Map as MapIcon, FileEdit } from 'lucide-react';

/**
 * Gleap-style bottom tab navigation for the public portal.
 * Stays fixed at the bottom of mobile screens, floats centered on desktop.
 */
const PortalBottomNav = ({ workspace, accessKey }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { subdomain } = useParams();
  const primaryColor = workspace?.settings?.primary_color || '#7c3aed';
  const settings = workspace?.settings || {};

  const keySuffix = accessKey ? `?key=${accessKey}` : '';
  const baseRoute = subdomain ? `/portal/${subdomain}` : '';

  const tabs = [
    { id: 'home', label: 'Home', icon: Home, path: `${baseRoute}${keySuffix}`, match: (p) => p === baseRoute || p === `${baseRoute}/` },
    { id: 'helpdesk', label: 'Helpdesk', icon: BookOpen, path: `${baseRoute}/helpdesk${keySuffix}`, match: (p) => p.includes('/helpdesk') },
    { id: 'news', label: 'News', icon: Newspaper, path: `${baseRoute}/news${keySuffix}`, match: (p) => p.includes('/news') },
    { id: 'roadmap', label: 'Roadmap', icon: MapIcon, path: `${baseRoute}/roadmap${keySuffix}`, match: (p) => p.includes('/roadmap') },
    { id: 'forms', label: 'Forms', icon: FileEdit, path: `${baseRoute}/forms${keySuffix}`, match: (p) => p.includes('/forms') },
  ];

  // Hide nav entirely if portal_layout = minimal, etc — for now always show
  if (settings.hide_bottom_nav) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 bg-white/95 backdrop-blur-md border border-zinc-200 rounded-2xl shadow-lg px-2 py-1.5 flex items-center gap-0.5" data-testid="portal-bottom-nav">
      {tabs.map(tab => {
        const Icon = tab.icon;
        const active = tab.match(location.pathname);
        return (
          <button
            key={tab.id}
            onClick={() => navigate(tab.path)}
            className={`flex flex-col items-center gap-0.5 px-3 sm:px-4 py-1.5 rounded-xl transition-all ${
              active ? 'text-white' : 'text-zinc-600 hover:bg-zinc-100'
            }`}
            style={active ? { backgroundColor: primaryColor } : {}}
            data-testid={`portal-tab-${tab.id}`}
          >
            <Icon className="h-4 w-4" />
            <span className="text-[10px] font-medium leading-none">{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default PortalBottomNav;
